import { Box, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
`;

export const Header = styled(Typography)(
  ({ theme }) => `
    font-color: ${theme.palette.brand.black};
    font-size: 2.5rem;
    font-weight: 400;
    line-height: 2rem;
    margin-top: 1.5625rem;
    margin-bottom:1.5rem;
`,
);

export const TextArea = styled(Box)`
  text-align: center;
  position: relative;
`;
